import type { ReactNode } from "react";
import { cn } from "../lib/cn.js";

export function PageHeader({
  title,
  subtitle,
  actions,
  className,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  className?: string;
}): JSX.Element {
  return (
    <div className={cn("flex items-start justify-between gap-4 pb-4", className)}>
      <div className="space-y-1">
        <h1 className="text-xl font-semibold text-dosia-text">{title}</h1>
        {subtitle ? (
          <p className="text-sm text-dosia-text-secondary">{subtitle}</p>
        ) : null}
      </div>
      {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
    </div>
  );
}
